import { Form, Input } from "antd";
import { useTranslation } from "react-i18next";
import { VALIDATION_RULES } from "../../../../constants";
import { FC, HTMLAttributes } from "react";
import SkeletonBox from "src/components/SkeletonBox/SkeletonBox";

type RequiredFieldsType = {
  name: string;
  displayName: string;
  type: "UserName" | "PhoneNumber" | "string" | "number";
};

type RequiredFieldsComponentType = {
  requiredFields?: RequiredFieldsType[];
  name: string;
  loading?: boolean;
};

const FieldSkeleton = () => (
  <div className="flex flex-col gap-2 flex-1 min-w-[160px]">
    <SkeletonBox className="h-3 w-24" />
    <SkeletonBox className="h-[52px] w-full rounded-md" />
  </div>
);

const RequiredFieldsLoading: FC<{ count?: number }> = ({ count = 2 }) => {
  return (
    <div className="flex flex-col gap-4 w-full">
      <SkeletonBox className="h-5 w-56" />
      <div className="flex w-full flex-col flex-wrap gap-4">
        {Array.from({ length: count }).map((_, i) => (
          <FieldSkeleton key={i} />
        ))}
      </div>
    </div>
  );
};

const RequiredFields: FC<RequiredFieldsComponentType & HTMLAttributes<HTMLDivElement>> = ({ requiredFields, name, loading }) => {
  const { t } = useTranslation();
  const isEmpty = !requiredFields || !requiredFields?.length;

  if (loading) {
    return <RequiredFieldsLoading count={requiredFields?.length || 2} />;
  }

  if (isEmpty) return null;


  return (
    <div className="flex w-full flex-col gap-2 font-semibold">
      <div className="text-lg font-semibold">{t("PointsExchange.exchange.requiredFieldsTitle")}</div>
      <div className="flex w-full flex-wrap gap-4">
        {requiredFields.map((field) => (
          <Form.Item
            key={field.name}
            name={[name, field.name]}
            label={field.displayName}
            colon={false}
            rules={VALIDATION_RULES[field.type]}
            className="m-0! flex-1! border-none! whitespace-nowrap!"
          >
            <Input
              className="p-4! border-border-default!"
              placeholder={t("PointsExchange.exchange.fieldPlaceholder", { field: field.displayName })}
            />
          </Form.Item>
        ))}
      </div>
    </div>
  );
};

export default RequiredFields;
